import React, {useCallback, useEffect, useState} from 'react'
import {api} from './Api.js'
import PreflightLoader, {parseISODuration} from "./PreflightLoader";
import {config} from "./Constants";
import styles from './css/Practice.module.css';

const WordModalWindow = ({ wordEn, text, onClose, showNotification, navigate }) => {
  const [word, setWord] = useState(null);
  const [loading, setLoading] = useState(true);
    const [expectedWaitTime, setExpectedWaitTime] = useState(0);

  const fetchWord = useCallback(async () => {
    setLoading(true);
      if (config.enablePreflight) {
          const waitRes = await api.fetchWaitTime('/word/translate', navigate, showNotification);
          if (api.isValidResponse(waitRes)) {
              setExpectedWaitTime(parseISODuration(waitRes.data.expectedWaitTime));
          }
      }
    const response = await api.fetchWord({wordEn, text}, navigate, showNotification);
    if (api.isValidResponse(response)) {
      setWord(response.data);
        setExpectedWaitTime(0);
    } else {
      onClose();
    }
    setLoading(false);
  }, [wordEn, text, navigate, showNotification, onClose]);

  useEffect(() => {
    fetchWord();
  }, [fetchWord]);

  if (loading) {
    return (
        <div className={styles.modalLoading}>
            <PreflightLoader expectedWaitTime={expectedWaitTime}/>
        </div>
    )
  }

  if (!word) return null;

  return (
      <article className={styles.wordModal} aria-label={`Translation for ${wordEn}`}>
          <div className={styles.wordModalBody}>
              <span className={styles.wordModalIcon}><i className="material-icons">translate</i></span>
              <h2 className={styles.wordTitle}>{wordEn}</h2>

              <div className={styles.wordTranslation}>
                  <span className={styles.wordTranslationLabel}>Translation</span>
                  <div className={styles.wordTranslationValue}>{word.ruValue}</div>
          </div>

          {word.value && word.value.toLowerCase() !== wordEn.toLowerCase() && (
              <div className={styles.dictionaryForm}>
                <span>
                  Dictionary form: <strong>{word.value}</strong>
                </span>
              </div>
          )}
        </div>
          <footer className={styles.wordModalFooter}>
          <button
              className="waves-effect waves-light btn-large blue darken-1"
              onClick={onClose}
          >
            <i className="material-icons left">close</i>
            Close
          </button>
          </footer>
      </article>
  );
}

export default WordModalWindow;
